/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { filestackDefaultOptions } from '../../utilities/filestack-package';
import Mixpanel from '../../../helpers/mixpanel';
import Button from './Button';
import FilestackComponent from './FilestackComponent';

import styles from '../../styles/views/components/UploadPhotoButton.module.scss';

const UploadPhotoButton = ({
  onSuccessUpload,
  chapterId,
  projectId,
  canUpload,
  maxFiles,
  variant,
  text,
  isButton,
  isImage,
  toolTipText,
}) => {
  const UPLOAD_BUTTON_NAME = useMemo(() => text || t('button.uploadPhotos', { ns: i18next.Namespace.COMMON }), [text]);
  const onSuccessUploadImage = (data) => {
    onSuccessUpload(data, chapterId, projectId);
    const { filesUploaded = [] } = data;
    Mixpanel.track(`Upload photo${filesUploaded.length > 1 ? '(s)' : ''}`, { numberOfPhotosUploaded: filesUploaded.length });
  };

  // TODO: catch error on uploading photo
  const onError = (error) => {
    console.error('error', error);
  };

  const renderUploadPhotoButton = useMemo(
    () => {
      const extendedFSOptions = {
        ...filestackDefaultOptions,
        maxFiles,
      };

      if (!canUpload) {
        return (
          <div className={styles.buttonWrapper}>
            {isButton && (
              <Button
                value={UPLOAD_BUTTON_NAME}
                variant={variant}
                color="gold"
                tooltip={toolTipText}
                isDisabled
              />
            )}
            {isImage && (
              <button
                className={[styles.uploadPhotoBtn, styles.disabled].join(' ')}
              >
                {text}
              </button>
            )}
          </div>
        );
      }

      return (
        <div className={styles.container}>
          <FilestackComponent
            options={extendedFSOptions}
            onSuccess={data => onSuccessUploadImage(data)}
            onError={onError}
            customRender={({ onPick }) => (
              <div className={styles.buttonWrapper} onClick={onPick}>
                {isButton && (
                  <Button
                    value={UPLOAD_BUTTON_NAME}
                    variant={variant}
                    color="gold"
                    onClick={() => Mixpanel.track('Add photo image')}
                  />
                )}
                {isImage && (
                  <button
                    className={styles.uploadPhotoBtn}
                    onClick={() => Mixpanel.track('Add photo image')}
                  >
                    {text}
                  </button>
                )}
              </div>
            )}
          />
        </div>
      );
    }, [canUpload, maxFiles, projectId, UPLOAD_BUTTON_NAME, text],
  );

  return renderUploadPhotoButton;
};

UploadPhotoButton.defaultProps = {
  canUpload: true,
  maxFiles: 1,
  chapterId: '',
  projectId: '',
  variant: 'primary',
  isButton: false,
  isImage: false,
  toolTipText: '',
};

UploadPhotoButton.propTypes = {
  canUpload: PropTypes.bool,
  maxFiles: PropTypes.number,
  onSuccessUpload: PropTypes.func.isRequired,
  chapterId: PropTypes.string,
  projectId: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.string.isRequired,
  isButton: PropTypes.bool,
  isImage: PropTypes.bool,
  toolTipText: PropTypes.string,
};

export default UploadPhotoButton;
